/* TILOA — module d'offres du Chiffon TILOA (snippets/tiloa-ch-offres.liquid, gabarit product.chiffon).

   Un seul gestionnaire d'ajout pour tout ce qui achète sur la fiche :
   - le bouton du module (submit du formulaire) ;
   - la barre collante (sections/tiloa-sticky-atc.liquid), qui relaie son clic vers le premier
     form[data-type="add-to-cart-form"] de la page, c'est-à-dire ce formulaire ;
   - les liens « Choisir mon lot » (#offre) font seulement défiler (assets/tiloa-chiffon.js).
   Toutes ces voies passent par l'événement « submit » du formulaire et par le même verrou
   « enVol » : un double clic, ou un clic sur le bouton puis sur la barre, ne produit qu'une
   requête. Après un ajout réussi, le bouton reste 1,4 s sur « Ajouté au panier » et ignore les
   clics : le 2e clic d'un double clic arrivé après la réponse n'ajoute pas un 2e lot.

   Contrat panier (repris de assets/tiloa-duo.js, copié et non branché) :
   - UNE seule requête POST JSON vers routes.cart_add_url + '.js', unités regroupées par variante
     (2 Noir + 2 Rose → deux entrées de quantité 2, jamais quatre entrées de 1), sections du tiroir
     rendues dans la même réponse (sections + sections_url) ;
   - succès : cartUpdate (source « tiloa-ch-offres »), rendu et ouverture du tiroir ;
   - erreur réseau, délai de 15 s, 4xx, 5xx, réponse illisible : relecture de /cart.js et
     comparaison avec le panier d'avant pour annoncer l'état réel ; aucun nouvel essai automatique ;
   - une garde de 30 s libère toujours le verrou.
   Montants : prix des variantes et montants des paliers lus dans le JSON rendu par Liquid ; ce
   script ne fait que les additionner, avec le format monétaire de la boutique.

   Événement « tiloa:bundle-change » (document), même forme que assets/tiloa-bundle.js, lu par la
   barre collante : { sectionId, quantity, total, compareAt, saving, totalFormatted, label } ;
   ajouts propres au chiffon : compareAtFormatted, offre (1 | 2+2 | 3+3), title. */
(function () {
  'use strict';

  var DELAI = 15000;        // POST /cart/add.js
  var DELAI_LECTURE = 5000; // GET /cart.js, rendu des sections du tiroir
  var DELAI_REF = 2500;     // attente maximale du panier de référence avant l'envoi
  var DELAI_GARDE = 30000;  // filet de sécurité : verrou toujours libéré
  var MSG_INCONNU = 'L\'ajout n\'a pas pu être confirmé. Vérifiez votre panier avant de réessayer.';
  var MSG_PARTIEL = 'Une partie seulement du lot a été ajoutée. Vérifiez votre panier avant de compléter.';
  var MSG_INDISPO = 'Cette couleur n\'est pas disponible. Choisissez-en une autre.';
  var MSG_EPUISE = 'Épuisé'; // même libellé que le rendu serveur du snippet

  function routes() {
    var r = window.routes || {};
    return { add: (r.cart_add_url || '/cart/add') + '.js', cart: r.cart_url || '/cart' };
  }

  // fetch + lecture JSON sous un délai maximal (en-têtes et corps compris).
  function jsonDelai(url, init, ms) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var opts = Object.assign({}, init || {});
    if (ctl) opts.signal = ctl.signal;
    var t = 0;
    var garde = new Promise(function (_, rej) {
      t = setTimeout(function () { if (ctl) ctl.abort(); rej(new Error('delai')); }, ms);
    });
    var travail = fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { r: r, j: j }; });
    });
    return Promise.race([travail, garde]).then(
      function (x) { clearTimeout(t); return x; },
      function (e) { clearTimeout(t); throw e; }
    );
  }

  function attendre(ms) {
    return new Promise(function (res) { setTimeout(function () { res(null); }, ms); });
  }

  function lireCart() {
    return jsonDelai(routes().cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' }, DELAI_LECTURE)
      .then(function (x) { if (!x.r.ok || !x.j) throw new Error('cart ' + x.r.status); return x.j; });
  }

  function publier(data) {
    if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tiloa-ch-offres', cartData: data });
    }
  }

  function quantites(cart, ids) {
    var q = {};
    ids.forEach(function (id) { q[id] = 0; });
    ((cart && cart.items) || []).forEach(function (l) { if (q.hasOwnProperty(l.variant_id)) q[l.variant_id] += l.quantity; });
    return q;
  }

  /* Format monétaire de la boutique (shop.money_format), espace insécable avant « € »
     comme le rendu Liquid du snippet. */
  function formatMoney(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}}€';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      var n = (number / 100).toFixed(precision).split('.');
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (n[1] ? decimal + n[1] : '');
    }
    var m = fmt.match(placeholder);
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, '\'', '.'); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, v).replace(/\s*€/, ' €').trim();
  }

  function init(root) {
    if (!root || root.__chPret) return;
    root.__chPret = true;

    var data;
    try { data = JSON.parse(root.querySelector('[data-ch-data]').textContent); } catch (e) { return; }
    var form = document.getElementById(root.getAttribute('data-form-id'));
    if (!form) return;
    var btn = form.querySelector('[data-ch-cta]');
    var label = form.querySelector('[data-ch-label]');
    var statut = form.querySelector('[data-ch-statut]');
    var live = form.querySelector('[data-ch-live]');
    var cartes = Array.prototype.slice.call(root.querySelectorAll('[data-ch-tier]'));
    var parId = {};
    (data.variants || []).forEach(function (v) { parId[String(v.id)] = v; });
    var tiers = {};
    (data.tiers || []).forEach(function (t) { tiers[t.n] = t; });

    var enVol = null;        // promesse de l'ajout en cours (verrou unique)
    var ref = null;          // panier de référence lu à l'intention { t, p }
    var minuteurAjoute = 0;
    var minuteurStatut = 0;
    var retourBarre = null;

    function carteActive() {
      for (var i = 0; i < cartes.length; i++) {
        var r = cartes[i].querySelector('[data-ch-radio]');
        if (r && r.checked) return cartes[i];
      }
      return cartes[0];
    }

    // Couleurs choisies, unité par unité, dans la carte active (sans sélecteur : variante par défaut).
    function unites(carte) {
      var t = tiers[+carte.getAttribute('data-ch-tier')] || { qty: 1 };
      var sels = carte.querySelectorAll('[data-ch-select]');
      var liste = [];
      for (var i = 0; i < t.qty; i++) {
        var s = sels[i];
        liste.push(String(s ? s.value : data.defaultVariant));
      }
      return liste;
    }

    // État du lot : total = somme des prix des unités − montant du palier (identique à la remise Shopify).
    function etat() {
      var carte = carteActive();
      var t = tiers[+carte.getAttribute('data-ch-tier')] || { n: 1, qty: 1, amount: 0, title: '' };
      var ids = unites(carte);
      var full = 0;
      var ok = true;
      ids.forEach(function (id) {
        var v = parId[id];
        if (!v || !v.available) ok = false;
        full += v ? v.price : 0;
      });
      var total = Math.max(0, full - (t.amount || 0));
      var compare = 0;
      // Barré fixé par le propriétaire (tN_compare, 03/11/2026) s'il existe, sinon quantité × prix pour un lot remisé.
      if (t.compare > total) compare = t.compare;
      else if (t.amount > 0) compare = full;
      else if (t.qty === 1 && t.barreUnite) {
        var v1 = parId[ids[0]];
        if (v1 && v1.compare > v1.price) compare = v1.compare;
      }
      return { carte: carte, tier: t, ids: ids, full: full, total: total, compare: compare, ok: ok };
    }

    // Lignes de la requête : une entrée par variante, quantités additionnées, ordre d'apparition.
    function lignes(e) {
      var ordre = [];
      var q = {};
      e.ids.forEach(function (id) {
        if (!q[id]) { q[id] = 0; ordre.push(id); }
        q[id] += 1;
      });
      return ordre.map(function (id) {
        var l = { id: Number(id), quantity: q[id] };
        if (data.propOffre) l.properties = { _offre: e.tier.cle };
        return l;
      });
    }

    function dire(txt, erreur) {
      clearTimeout(minuteurStatut);
      if (!statut) return;
      statut.textContent = txt || '';
      statut.classList.toggle('is-error', !!erreur && !!txt);
    }

    function signalerErreur(msg) { dire(msg || data.errorLabel, true); }

    function rendre(annoncer) {
      var e = etat();
      cartes.forEach(function (c) {
        var on = c === e.carte;
        c.classList.toggle('is-selected', on);
      });
      // Montants de la carte active (variantes de prix différents : total recalculé).
      var tot = e.carte.querySelector('[data-ch-total]');
      if (tot) tot.textContent = formatMoney(e.total, data.moneyFormat);
      var cmpVal = e.carte.querySelector('[data-ch-compare-val]');
      if (cmpVal && e.compare) cmpVal.textContent = formatMoney(e.compare, data.moneyFormat);
      // Prix par chiffon et économie (mêmes formules que le snippet : arrondis au centime et au pour cent).
      var unite = e.carte.querySelector('[data-ch-unite]');
      if (unite && e.tier.qty > 1) unite.textContent = formatMoney(Math.round(e.total / e.tier.qty), data.moneyFormat);
      var eco = e.carte.querySelector('[data-ch-eco-val]');
      if (eco && e.compare > e.total) eco.textContent = String(Math.round((e.compare - e.total) * 100 / e.compare));
      if (!btn.classList.contains('is-adding') && !btn.classList.contains('is-added')) {
        // Sans sélecteur (une seule couleur), « choisissez-en une autre » n'a pas de sens : « Épuisé ».
        label.textContent = e.ok ? data.atcLabel : (e.carte.querySelector('[data-ch-select]') ? MSG_INDISPO : MSG_EPUISE);
        if (e.ok) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
      }
      var totalTxt = formatMoney(e.total, data.moneyFormat);
      if (annoncer && live) {
        live.textContent = e.tier.title + ' : ' + totalTxt + (e.tier.qty > 1 ? ', ' + e.tier.qty + ' chiffons' : '');
      }
      document.dispatchEvent(new CustomEvent('tiloa:bundle-change', {
        detail: {
          sectionId: data.uid,
          quantity: e.tier.qty,
          total: e.total,
          compareAt: e.compare || e.full,
          saving: Math.max(0, (e.compare || e.full) - e.total),
          totalFormatted: totalTxt,
          compareAtFormatted: e.compare ? formatMoney(e.compare, data.moneyFormat) : '',
          label: e.tier.title,
          title: e.tier.title,
          offre: e.tier.cle
        }
      }));
      return e;
    }

    // Changement de carte : les couleurs déjà choisies pour les premières unités sont reprises.
    function reporterCouleurs(depuis, vers) {
      if (!depuis || depuis === vers) return;
      var a = depuis.querySelectorAll('[data-ch-select]');
      var b = vers.querySelectorAll('[data-ch-select]');
      for (var i = 0; i < b.length && i < a.length; i++) {
        var opt = b[i].querySelector('option[value="' + a[i].value + '"]');
        if (opt && !opt.disabled) b[i].value = a[i].value;
      }
    }

    var precedente = carteActive();
    cartes.forEach(function (c) {
      var r = c.querySelector('[data-ch-radio]');
      if (!r) return;
      r.addEventListener('change', function () {
        if (!r.checked) return;
        reporterCouleurs(precedente, c);
        precedente = c;
        dire('', false);
        rendre(true);
      });
    });
    root.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('[data-ch-select]')) { dire('', false); rendre(false); }
    });

    // Référence du panier avant l'ajout : lue à l'intention (pointeur, focus), réutilisée 5 s au plus,
    // oubliée dès que le panier change ou que l'onglet passe en arrière-plan.
    function amorcer() {
      if (!ref || Date.now() - ref.t > 5000) {
        ref = { t: Date.now(), p: lireCart().catch(function () { return null; }) };
      }
      return ref.p;
    }
    btn.addEventListener('pointerdown', amorcer, { passive: true });
    btn.addEventListener('focus', amorcer);
    root._chAmorcer = amorcer;
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (!enVol) ref = null; });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden && !enVol) ref = null; });

    function occupe(on) {
      var sb = document.querySelector('.sticky-atc [data-sticky-button]');
      if (on) {
        clearTimeout(minuteurAjoute);
        btn.classList.remove('is-added');
        btn.classList.add('is-adding');
        btn.setAttribute('aria-busy', 'true');
        // Clics supplémentaires pendant l'ajout : non mesurés (assets/tiloa-analytics.js ignore [data-tiloa-relay]).
        form.setAttribute('data-tiloa-relay', 'busy');
        if (sb) sb.setAttribute('data-tiloa-relay', 'busy');
        label.textContent = data.addingLabel;
      } else {
        btn.classList.remove('is-adding');
        btn.removeAttribute('aria-busy');
        if (!btn.classList.contains('is-added')) form.removeAttribute('data-tiloa-relay');
        if (sb && sb.getAttribute('data-tiloa-relay') === 'busy') sb.removeAttribute('data-tiloa-relay');
        if (!btn.classList.contains('is-added')) rendre(false);
      }
    }

    // Mesure first-party facultative : ce que le client a choisi, une fois par ajout constaté.
    function mesurer(e, partiel) {
      var A = window.TiloaAnalytics;
      if (!e || !A || typeof A.track !== 'function') return;
      try {
        A.track('bundle_add_to_cart', {
          bundle: 'chiffon-' + e.tier.cle,
          quantity: partiel ? partiel.quantity : e.tier.qty,
          partial: !!partiel,
          value: partiel ? null : e.total / 100,
          value_basis: partiel ? 'partial_unknown' : 'offer_total',
          product_id: data.productId,
          variant_ids: e.ids.join(','),
          analytics_section: 'buybox',
          analytics_action: 'bundle_add_to_cart'
        });
      } catch (err) {}
    }

    function ajoute(e) {
      mesurer(e);
      btn.classList.add('is-added');
      form.setAttribute('data-tiloa-relay', 'busy');
      label.textContent = data.addedLabel;
      dire(data.addedLabel, false);
      minuteurAjoute = setTimeout(function () {
        btn.classList.remove('is-added');
        if (!enVol) form.removeAttribute('data-tiloa-relay');
        rendre(false);
      }, 1400);
      minuteurStatut = setTimeout(function () {
        if (statut && statut.textContent === data.addedLabel) dire('', false);
      }, 4000);
    }

    function tiroir() { return document.querySelector('cart-drawer'); }

    function succes(rep, e) {
      var drawer = tiroir();
      if (!drawer || typeof drawer.renderContents !== 'function') {
        window.location.href = routes().cart;
        return;
      }
      publier(rep);
      try {
        drawer.renderContents(rep);
        drawer.classList.remove('is-empty');
      } catch (err) {
        // Ajout confirmé par Shopify mais fragments absents : rendu à partir du panier réel.
        return lireCart().then(function (c) {
          return rendreTiroirReel(c, true).then(function () { ajoute(e); });
        }, function () { ajoute(e); });
      }
      ajoute(e);
    }

    // Rendu du tiroir à partir de l'état réel (Section Rendering API sur la page courante).
    function rendreTiroirReel(cart, ouvrir) {
      var drawer = tiroir();
      if (!drawer) return Promise.resolve();
      var ids = (typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : []).map(function (x) { return x.id; });
      if (!ids.length) return Promise.resolve();
      return jsonDelai(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { cache: 'no-store', credentials: 'same-origin' }, DELAI_LECTURE)
        .then(function (x) {
          var sections = x.j;
          if (!x.r.ok || !sections) throw new Error('sections');
          publier(cart);
          if (ouvrir) {
            drawer.renderContents({ sections: sections });
            drawer.classList.remove('is-empty');
          } else {
            ids.forEach(function (id) {
              var sel = id === 'cart-drawer' ? '#CartDrawer' : null;
              var el = sel ? document.querySelector(sel) : document.getElementById(id);
              if (el && sections[id] && typeof drawer.getSectionInnerHTML === 'function') el.innerHTML = drawer.getSectionInnerHTML(sections[id], sel || undefined);
            });
          }
        })
        .catch(function () { publier(cart); });
    }

    // Après une réponse incertaine : on lit le panier, on compare, on dit vrai.
    function relire(avant, items, e) {
      var ids = items.map(function (i) { return i.id; });
      return lireCart().then(function (apres) {
        if (!avant) {
          signalerErreur(MSG_INCONNU);
          return rendreTiroirReel(apres, false);
        }
        var qa = quantites(avant, ids), qp = quantites(apres, ids);
        var attendu = 0, recu = 0;
        items.forEach(function (i) {
          attendu += i.quantity;
          recu += Math.max(0, Math.min(i.quantity, qp[i.id] - qa[i.id]));
        });
        if (recu >= attendu) {
          return rendreTiroirReel(apres, true).then(function () { ajoute(e); });
        }
        if (recu > 0) {
          mesurer(e, { quantity: recu });
          dire(MSG_PARTIEL, true);
          return rendreTiroirReel(apres, true);
        }
        signalerErreur(data.errorLabel);
      }).catch(function () {
        signalerErreur(MSG_INCONNU);
      });
    }

    // Tiroir refermé après un ajout lancé depuis la barre collante : focus rendu au bouton de la
    // barre une fois réaffichée, sinon au bouton du module (jamais sur <body>).
    (function suivreTiroir() {
      var drawer = tiroir();
      if (!drawer || drawer.__chSuivi) return;
      drawer.__chSuivi = true;
      var ouvert = drawer.classList.contains('active');
      new MutationObserver(function () {
        var maintenant = drawer.classList.contains('active');
        if (ouvert && !maintenant && retourBarre) {
          var cible = retourBarre;
          retourBarre = null;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              var ae = document.activeElement;
              if (ae && ae !== document.body && ae !== document.documentElement && !drawer.contains(ae)) return;
              try { cible.focus({ preventScroll: true }); } catch (x) {}
              if (document.activeElement !== cible) {
                try { btn.focus({ preventScroll: true }); } catch (x2) {}
              }
            });
          });
        }
        ouvert = maintenant;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    })();

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (enVol) return; // bouton, barre collante : un seul verrou
      if (btn.classList.contains('is-added')) return; // double clic après la réponse : pas de 2e lot
      // Tiroir ouvert (classe posée dès l'ouverture, avant la fin du glissement) : un appui tardif sur
      // un appareil lent, après la fenêtre « Ajouté » de 1,4 s, n'ajoute pas un 2e lot. Le tiroir
      // recouvre le bouton et la barre collante est masquée : aucun geste volontaire n'est perdu.
      var tiroirOuvert = tiroir();
      if (tiroirOuvert && tiroirOuvert.classList.contains('active')) return;
      if (btn.disabled) return;
      var e = etat();
      if (!e.ok) { signalerErreur(MSG_INDISPO); return; }
      var items = lignes(e);
      dire('', false);

      // Origine : la barre collante relaie son clic en posant data-tiloa-relay sur ce bouton
      // le temps du click() (submit synchrone).
      var viaBarre = btn.hasAttribute('data-tiloa-relay');
      var boutonBarre = viaBarre ? document.querySelector('.sticky-atc [data-sticky-button]') : null;
      retourBarre = null;

      var drawer = tiroir();
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') {
          var ae = document.activeElement;
          if (boutonBarre) {
            drawer.setActiveElement(boutonBarre);
            retourBarre = boutonBarre;
          } else {
            drawer.setActiveElement(ae && ae !== document.body && !(ae.closest && ae.closest('.sticky-atc')) ? ae : btn);
          }
        }
      }
      occupe(true);

      var fini = false;
      var garde = 0;
      function terminer() {
        if (fini) return;
        fini = true;
        clearTimeout(garde);
        enVol = null;
        ref = null;
        occupe(false);
      }
      garde = setTimeout(function () {
        if (fini) return;
        signalerErreur(MSG_INCONNU);
        terminer();
      }, DELAI_GARDE);

      var avantP = Promise.race([amorcer(), attendre(DELAI_REF)]);
      enVol = avantP.then(function (avant) {
        var init = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          credentials: 'same-origin'
        };
        return jsonDelai(routes().add, init, DELAI)
          .then(function (x) {
            return { ok: x.r.ok && x.j && !x.j.status, j: x.j };
          })
          .then(function (x) {
            if (x.ok) return succes(x.j, e);
            return relire(avant, items, e);
          }, function () {
            return relire(avant, items, e);
          });
      }).catch(function () {
        signalerErreur(MSG_INCONNU);
      }).then(terminer);
    });

    rendre(false);
  }

  function tout() {
    document.querySelectorAll('[data-ch-offres]').forEach(init);
  }

  if (!window.__tiloaChOffresGlobal) {
    window.__tiloaChOffresGlobal = true;
    // Barre collante : la référence du panier part dès que le doigt touche.
    document.addEventListener('pointerdown', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('[data-sticky-button]')) return;
      var root = document.querySelector('[data-ch-offres]');
      if (root && root._chAmorcer) root._chAmorcer();
    }, { passive: true, capture: true });
    document.addEventListener('shopify:section:load', tout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
})();
